<template>
  <div class="">
    <ZnBreadcrumb />
    <div
      class="main-content"
      v-title
      data-title="订单统计管理_试剂采购库存管理系统"
    >
      <div class="search-type">
        <ul class="clearfix">
          <li class="last">
            <el-input
              placeholder="请输入试剂名/CAS号/试剂编号"
              v-model="alias"
              @keyup.enter.native="reagentList()"
              prefix-icon="el-icon-search"
            />
            <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 300px;"
                v-model="queryTime"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-button size="small" type="primary" @click="reagentList()" style="margin-left: 15px">
              快速查询
            </el-button>
          </li>
        </ul>
      </div>
      <div class="table-container">
        <el-table
          :data="recordList"
          height="600px"
          row-key="reagentId"
          :expand-row-keys="expands"
          @expand-change="getReagnetDetails"
          :header-cell-style="{
            background: '#F8FAFC',
            color: '#000000',
            fontWeight: 700,
            height: '54px',
          }"
          border
          style="width: 100%"
        >
          <template slot="empty">
            <img src="../../assets/images/empty.png" class="empty" />
            <p>暂无记录</p>
          </template>

          <el-table-column type="expand">
            <template>
              <el-table
                :data="reagentDetails"
                style="width: 70%"
                :header-cell-style="{
                  background: '#fff2cc',
                  color: '#000000',
                  border: '1px solid tan',
                }"
                :cell-style="{
                  background: '#fff2cc',
                  border: '1px solid tan',
                }"
              >
                <el-table-column width="50px" type="index" :index="indexMethod" label="序号">
                </el-table-column>

                <el-table-column prop="gmtCreate" width="200px" label="领用时间">
                </el-table-column>

                <el-table-column width="150px" prop="createUsername" label="领用人">
                </el-table-column>



                <el-table-column width="150px" prop="borrowNum" label="领用剂量">
                  <template v-slot="scope">
                    <span >{{ scope.row.borrowNum | numFilter }}{{ unit(scope.row.reagentWeightUnit) }}</span>
                  </template>
                </el-table-column>
<!--                <el-table-column width="150px" prop="borrowNum" label="状态">-->
<!--                  <template v-slot="scope">-->
<!--                    {{ $store.state.borrowRecordStatus[scope.row.operation] }}-->
<!--                  </template>-->
<!--                </el-table-column>-->
                <el-table-column prop="remark" label="备注"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="" label="试剂编号"> 
            <template slot-scope="scope">
              <span v-if="scope.row.lockerReagent && scope.row.lockerReagent.code">{{scope.row.lockerReagent.code}}</span>
              <span v-else>{{ scope.row.reagentId }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reagentName" label="试剂名称">
          </el-table-column>
          <el-table-column prop="casNo" label="CAS号"> </el-table-column>
          <el-table-column prop="lockerReagent.goodsSupplierName" label="品牌">
          </el-table-column>
          <el-table-column prop="lockerOrders.supplierName" label="供应商">
          </el-table-column>
          <el-table-column prop="" label="试剂位置">
            <template v-slot="scope">
              {{ scope.row.cabName }}（{{ scope.row.numX }}，{{
                scope.row.numY
              }}）
            </template>
          </el-table-column>
          <el-table-column prop="lockerOrders.nickName" label="购买人">
          </el-table-column>
          <el-table-column prop="lockerOrders.gmtCreate" label="购买时间">
          </el-table-column>
          <el-table-column prop="" label="金额">
            <template v-slot="scope">
              <span v-if="scope.row.lockerOrders && scope.row.lockerOrders.orderAmount"
                >{{ scope.row.lockerOrders.orderAmount }}元</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="" label="剩余剂量/总剂量">
            <template v-slot="scope">
              <span v-if="scope.row.lockerReagent"
                >{{ scope.row.lockerReagent.reagentRemainWeight | numFilter
                }}{{ unit(scope.row.reagentWeightUnit) }}/{{
                  scope.row.lockerReagent.reagentWeight | numFilter
                }}{{ unit(scope.row.reagentWeightUnit) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="" label="领用剂量">
            <template v-slot="scope">
              <span v-if="scope.row.lockerReagent">
                {{ (scope.row.lockerReagent.borrowAmount) | numFilter}}
                {{ unit(scope.row.reagentWeightUnit) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="领用记录">
            <template v-slot="scope">
              <span v-if="scope.row.borrowReagentNum">
                <el-link type="primary" :underline="false" @click="getReagnetDetails(scope.row)">
                  {{ scope.row.borrowReagentNum }}条
                </el-link>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float: right"
          :pager-count="5"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagedata.pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pagedata.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      queryTime: [],
      expands: [],
      reagentDetails: [],
      orderStatus: "",
      auditStatus: "",
      alias: "",
      recordList: [],
      total: 0,
      totalpage: 0,
      pagedata: {
        pageNum: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.reagentList();
  },
  filters:{
    numFilter (value) {
      // 截取当前数据到小数点后三位
      // let tempVal = parseFloat(value).toFixed(3)
      // let realVal = tempVal.substring(0, tempVal.length - 1)
      return Math.floor(value*1000)/1000;
      // return Math.round(value*100)/100
      // return realVal
    },
  },
  methods: {
    indexMethod(index){
      return this.reagentDetails.length - index
    },
    reagentNumClick(row){
      console.log(row);
      if(this.expands.includes(row.reagentId)){
        this.expands = this.expands.filter(val => val != row.reagentId);
      }else{
        this.expands.push(row.reagentId)
      }
    },
    // 分页 size 改变
    handleSizeChange(val) {
      this.pagedata.pageSize = val;
      this.reagentList();
    },
    // 当前 页码 改变
    handleCurrentChange(val) {
      this.pagedata.pageNum = val;
      this.reagentList();
    },

    // 单位
    unit(reagentWeightUnit) {
      //单位适配
      return reagentWeightUnit == 1
        ? "mL"
        : reagentWeightUnit == 2
        ? "g"
        : reagentWeightUnit == 3
        ? "mg"
        : reagentWeightUnit == 4
        ? "L"
        : reagentWeightUnit == 5
        ? "kg"
        : reagentWeightUnit == 6
        ? "KU"
        : reagentWeightUnit == 7
        ? "U"
        : "";
    },

    // expands 只展开一行
    expandsOneRow(row, expandedRows) {
      if (expandedRows.length) {
        //说明展开了
        this.expands = [];
        if (row) {
          this.expands.push(row.reagentId); //只展开当前行id
        }
      } else {
        //说明收起了
        this.expands = [];
      }
    },

    // 获取试剂详情展开按钮
    getReagnetDetails(row, expandedRows) {
      if (this.expands.includes(row.reagentId)) {
        //已经展开的话，就关闭，移除在expands中的key
        this.expands = this.expands.filter((val) => val !== row.reagentId);
      } else {
        this.getDetailFn(row.reagentId).then(() => {
          this.expands.push(row.reagentId);
          this.expandsOneRow(row, this.expands); // 收起
        });
      }
    },

    // 获取试剂详情异步请求
    //异步请求接口
    async getDetailFn(reagentId) {
      let res = await this.$apiFetch.get(
        `/lockerBorrowRecord/reagentDetailsBorrowRecord/${reagentId}`
      );
      this.reagentDetails = res.data;
    },

    changePage(data) {
      this.pagedata.pageNum = data;
      this.reagentList();
    },
    //试剂柜列表
    reagentList() {
      let startTime = null;
      let endTime = null;
      if(null != this.queryTime && this.queryTime.length > 0){
        startTime = this.queryTime[0];
        endTime = this.queryTime[1];
      }
      this.$apiFetch
        .get(`/lockerBorrowRecord/reagentBorrowRecord`, {
          pageNum: this.pagedata.pageNum,
          pageSize: this.pagedata.pageSize,
          reagentName: this.alias.trim(),
          startTime: startTime,
          endTime: endTime,
        })
        .then((res) => {
          this.total = res.data.total;
          this.pagedata.pageNum = res.data.pageNum;
          this.totalpage = res.data.pages;
          this.recordList = res.data.list;
          console.log("rescordList = ", this.recordList);
        });
    },
    goodsDetails(row) {
      let id = row.id;
      let price = row.payAmount;
      let No = row.orderNo;
      this.$router.push({ path: `goodsDetails/${id}?price=${price}&No=${No}` });
    },
    //我的选购
    myCart() {
      this.$apiFetch.get(`/lockerShopCart/myCartNum`).then((res) => {
        this.myCartNum = res.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
/*修改展开按钮的样式 start*/
/deep/ .el-table__expand-icon {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
/*2.展开按钮未点击的样式是加号带边框*/
/deep/ .el-table__expand-icon .el-icon-arrow-right:before {
  // content: "\e6d9";
  padding: 2px;
  color: #478aff;
  font-weight: 900;
}
/*3.展开按钮点击后的样式是减号带边框*/
/deep/ .el-table__expand-icon--expanded .el-icon-arrow-right:before {
  content: "\e6df";
  color: #478aff;
}
.no-date {
  min-height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    display: block;
    width: 148px;
  }
  p {
    color: #b1c4e2;
    font-size: 14px;
    line-height: 20px;
    margin-top: 14px;
    text-align: center;
  }
}

.search-type {
  background-color: #ffffff;
  padding: 20px;
  border-radius: 4px 4px 0 0;
  border-bottom: 1px solid #eef2f8;
  ul {
    li {
      display: flex;
      align-items: center;
      .el-input {
        margin-right: var(--zng-gap);
        width: 380px;
      }
      /deep/ .el-select {
        margin-right: 20px;
      }
      /*   img {
        width: 14px;
        display: block;
        position: absolute;
        top: 11px;
        left: 9px;
      }
      input {
        width: 380px;
        height: 36px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        padding-left: 28px;
      }
      button {
        width: 98px;
        height: 36px;
        background: #478aff;
        border-radius: 4px;
        font-size: 12px;
        color: #ffffff;
        margin-left: 12px;
      } */
    }
    // li.last {
    //   margin-left: 100px;
    // }
  }
}
/deep/.el-table .cell {
  button {
    margin-right: 20px;
  }
}
.table-container {
  border-radius: 4px;
  padding: 20px;
  background-color: #ffffff;
  .empty {
    width: 196px;
    margin-top: 38px;
    height: unset;
  }
}
.el-popover {
  p {
    color: #333333;
    font-size: 12px;
    line-height: 17px;
    padding-bottom: 8px;
  }
  button {
    display: block;
    margin: 0 auto;
  }
}
</style>
